import { useEffect, useState } from 'react';
import { HopperIcon } from '../ui/icons/HopperIcon';
import { fetchPost, type PublicVenuePost } from './postApi';
import './post-detail.css';

function publishedDate(value: string | null): string {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' }).format(parsed);
}

export function PostScreen({ postId }: { postId: string }) {
  const [post, setPost] = useState<PublicVenuePost | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'auto';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setNotFound(false);

    fetchPost(postId, controller.signal)
      .then(setPost)
      .catch((reason: unknown) => {
        if (reason instanceof DOMException && reason.name === 'AbortError') return;
        setPost(null);
        setNotFound(true);
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  }, [postId]);

  if (loading) {
    return <main className="social-page"><div className="social-loading">Открываем пост…</div></main>;
  }

  if (notFound || !post) {
    return (
      <main className="social-page">
        <section className="user-profile-card">
          <h1>Пост недоступен</h1>
          <p>Он мог быть снят с публикации, отправлен в архив или скрыт модерацией.</p>
          <button className="social-back" type="button" onClick={() => window.location.assign('/pulse')}>
            <HopperIcon name="arrow-left" size={17} />
            <span>В Пульс</span>
          </button>
        </section>
      </main>
    );
  }

  const venueName = post.venue.name?.trim() || 'Заведение Хоппера';

  return (
    <main className="social-page" aria-labelledby="venue-post-title">
      <button className="social-back" type="button" onClick={() => window.location.assign(`/venue/${encodeURIComponent(post.venue.id)}`)}>
        <HopperIcon name="arrow-left" size={17} />
        <span>К заведению</span>
      </button>

      <article className="user-profile-card post-detail-card">
        <button
          type="button"
          className="pulse-feed-card__author post-detail__author"
          onClick={() => window.location.assign(`/venue/${encodeURIComponent(post.venue.id)}`)}
        >
          {post.venue.avatar_url ? (
            <img className="pulse-feed-card__author-avatar" src={post.venue.avatar_url} alt="" />
          ) : (
            <span className="pulse-feed-card__author-avatar is-empty" aria-hidden="true">{venueName.slice(0, 1).toUpperCase()}</span>
          )}
          <span className="pulse-feed-card__author-copy">
            <strong className="pulse-feed-card__author-name">{venueName}</strong>
            <span className="pulse-feed-card__meta">{publishedDate(post.published_at)}</span>
          </span>
        </button>

        <h1 id="venue-post-title" className="post-detail__title">{post.title}</h1>
        {post.cover && (
          <img
            src={post.cover.url}
            alt="Обложка поста"
            loading="eager"
            className="post-detail__cover"
          />
        )}
        <p className="post-detail__body">{post.body}</p>
      </article>
    </main>
  );
}
